import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";




const Datatable = () => {
  const [data, setData] = useState([]);

    const userColumns = [
      { field: "_id", headerName: "ID", width: 100 },
      {
        field: "name",
        headerName: "User",
        width: 150,
        renderCell: (params) => {
          const { name, profileImg } = params.row;
          return (
            <div className="cellWithImg">
              <img className="cellImg" src={`http://localhost:8000/public/userImages/${profileImg}`} alt="avatar" />
              {name}
            </div>
          );
        },
      },
      { field: "email", headerName: "Email", width: 150 },
      { field: "nickname", headerName: "NickName", width: 150 },
      {
        field: "address",
        headerName: "Address",
        width: 250,
        renderCell: (params) => {
          const { address} = params.row;
          return <div className={`cellWithStatus ${address}`}>{address}</div>;
        },
      },
    ];


  useEffect(() => {
    fetch("http://localhost:8000/users/allUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);

  const handleDelete = (id) => {
        fetch("http://localhost:8000/users/deleteOne", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
          },
      body:JSON.stringify({userId:id})
    })
    setData(data.filter((item) => item._id !== id));
  };

  function getRowId(data) {
    return data._id;
  }

    const actionColumn = [
      {
        field: "action",
        headerName: "Action",
        width: 200,
        renderCell: (params) => {
          const {_id}  = params.row;
          return (
            <div className="cellAction">
              <Link
                to={`${_id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
              <div className="deleteButton" onClick={() => handleDelete(_id)}>
                Delete
              </div>
            </div>
          );
        },
      },
    ];

  return (
    <div className="datatable">
      {/* <div className="datatableTitle">
        Add New User
        <Link to="/adminUsers/adminNew" className="link">
          Add New
        </Link>
      </div> */}
      <DataGrid
        className="datagrid"
        getRowId={getRowId}
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
    </div>
  );
};

export default Datatable;
